import { Menu, X } from "lucide-react";
import { useState } from "react";
import { Link, NavLink, Outlet } from "react-router-dom";

import { useAuth } from "../context/AuthContext";
import BrandMark from "./BrandMark";

const nav = [
  ["/functies", "Functies"],
  ["/voor-werkgevers", "Voor werkgevers"],
  ["/prijzen", "Prijzen"],
  ["/faq", "FAQ"],
] as const;

export default function MarketingLayout() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  return (
    <div className="marketing-site">
      <header className="marketing-header">
        <div className="marketing-header-inner">
          <BrandMark />
          <nav className={open ? "is-open" : ""} aria-label="Website navigatie">
            {nav.map(([to, label]) => (
              <NavLink key={to} to={to} onClick={() => setOpen(false)}>
                {label}
              </NavLink>
            ))}
            <Link className="marketing-mobile-login" to={user ? "/app" : "/registreren"} onClick={() => setOpen(false)}>
              {user ? "Naar app" : "Gratis beginnen"}
            </Link>
          </nav>
          <div className="marketing-header-actions">
            <Link className="text-button" to={user ? "/app" : "/inloggen"}>
              {user ? "Naar app" : "Inloggen"}
            </Link>
            <Link className="button primary" to={user ? "/app" : "/registreren"}>
              {user ? "Open dashboard" : "Gratis beginnen"}
            </Link>
          </div>
          <button
            className="icon-button marketing-menu"
            type="button"
            onClick={() => setOpen((value) => !value)}
            aria-label={open ? "Menu sluiten" : "Menu openen"}
          >
            {open ? <X size={21} /> : <Menu size={21} />}
          </button>
        </div>
      </header>
      <main>
        <Outlet />
      </main>
      <footer className="marketing-footer">
        <div className="footer-grid">
          <div className="footer-brand">
            <BrandMark />
            <p>Verlof plannen zonder losse Excel-bestanden.</p>
          </div>
          <div>
            <strong>Product</strong>
            <Link to="/functies">Functies</Link>
            <Link to="/prijzen">Prijzen</Link>
            <Link to="/voor-werkgevers">Werkgevers</Link>
          </div>
          <div>
            <strong>Bedrijf</strong>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact</Link>
            <Link to="/over-ons">Over ons</Link>
          </div>
          <div>
            <strong>Juridisch</strong>
            <Link to="/privacy">Privacy</Link>
            <Link to="/cookies">Cookies</Link>
            <Link to="/algemene-voorwaarden">Algemene voorwaarden</Link>
          </div>
        </div>
        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} DeVerlofkaart</span>
          <span>Gemaakt voor helder verlofbeheer.</span>
        </div>
      </footer>
    </div>
  );
}
